'use client';
import { useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';

import {
	loadFromSessionStorage,
	saveToSessionStorage,
	ssKeys,
} from '~features/storage';

import {
	IdHideEmailConfirmModal,
	IdShowEmailConfirmModal,
} from '../../constants';
import { HiddenDiv } from '../EmailConfirmModal/styles';

export const EmailConfirmManager = () => {
	const searchParams = useSearchParams();

	const [confirm, setConfirm] = useState<string | null>(null);

	const getConfirm = () => {
		if (
			searchParams.get('confirm') === '1' ||
			searchParams.get('confirm') === '0' ||
			loadFromSessionStorage(ssKeys.CONFIRM_EMAIL, null)
		) {
			saveToSessionStorage(ssKeys.CONFIRM_EMAIL, searchParams.get('confirm'));
			return searchParams.get('confirm');
		}

		return null;
	};

	useEffect(() => {
		setConfirm(getConfirm());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<>
			{confirm === '1' && <HiddenDiv id={IdShowEmailConfirmModal} />}
			{confirm === '0' && <HiddenDiv id={IdHideEmailConfirmModal} />}
		</>
	);
};
